import styled from 'styled-components'
import React from 'react'

export const RelatedLinksSection = styled.section`
  margin: 3rem 0 5rem;
  padding: 2rem 2.25rem;
  background: rgba(255, 255, 255, 0.55);
  border-radius: 8px;
`;

export const RelatedLinksTitle = styled.h2`
  margin: 0 0 1rem;
  font-size: 1.35rem;
  font-weight: 500;
`;

export const RelatedLinksList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

export const RelatedLinkItem = styled.li`
  border-top: 1px solid rgba(0, 0, 0, 0.15);

  &:last-child {
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  }
`;

export const RelatedLink = styled.a`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1.5rem;
  padding: 1rem 0;

  color: #242424;
  font-size: 1rem;
  line-height: 1.4;
  text-decoration: none;

  transition:
    color 150ms ease,
    padding-left 150ms ease;

  /* &::after {
    content: "↗";
    flex-shrink: 0;
    font-size: 1.1rem;
    color: #666;
  } */

  &:hover,
  &:focus-visible {
    color: #54203f;
    padding-left: 0.4rem;
  }

  &:focus-visible {
    outline: 2px solid #54203f;
    outline-offset: 4px;
  }
`;


export default function RelatedLinks({
  links = [],
  title = "Further reading",
  className,
}) {
  if (!links.length) return null

  return (
    <RelatedLinksSection aria-label={title} className={className}>
      <RelatedLinksTitle>{title}</RelatedLinksTitle>

      <RelatedLinksList>
        {links.map(({ href, text }) => (
          <RelatedLinkItem key={href}>
            <RelatedLink
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {text}
            </RelatedLink>
          </RelatedLinkItem>
        ))}
      </RelatedLinksList>
    </RelatedLinksSection>
  )
}